var at = Object.defineProperty;
var it = (n, e, t) => e in n ? at(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t;
var Pe = (n, e, t) => (it(n, typeof e != "symbol" ? e + "" : e, t), t);
import { utils as C, BaseDocument as Ve, applyMixins as ot, actions as ct } from "document-model/document";
const dt = {
  id: "powerhouse/account-snapshot",
  name: "AccountSnapshot",
  extension: "phas",
  description: "",
  author: {
    name: "powerhouse",
    website: "https://powerhouse.inc/"
  },
  specifications: [
    {
      version: 1,
      changeLog: [],
      state: {
        global: {
          schema: `type AccountSnapshotState {
	id: ID!
    ownerId: ID
    ownerType: String
    period: String
    start: String
    end: String
    actualsComparison: [ActualsComparison]
    snapshotAccount: [SnapshotAccount]
}

type ActualsComparison {
    currency: String
    month: String
    reportedActuals: Float
    netExpenses: ActualsComparisonNetExpenses
}

type ActualsComparisonNetExpenses {
    offChainIncluded: ActualsComparisonNetExpensesItem
    onChainOnly: ActualsComparisonNetExpensesItem!
}

type ActualsComparisonNetExpensesItem {
    amount: Float
    difference: Float
}

type SnapshotAccount {
    accountAddress: String
    accountLabel: String
    accountType: String
    groupAccountId: ID
    id: ID!
    offChain: Boolean
    upstreamAccountId: ID
    snapshotAccountBalance: [SnapshotAccountBalance]
    snapshotAccountTransaction: [SnapshotAccountTransaction]
}

type SnapshotAccountBalance {
    id: ID
    includesOffChain: Boolean
    inflow: Float
    initialBalance: Float
    newBalance: Float
    outflow: Float
    token: String
}

type SnapshotAccountTransaction {
    amount: Float
    block: Int
    counterParty: String
    counterPartyName: String
    id: ID!
    timestamp: String
    token: String
    txHash: String
    txLabel: String
}`,
          initialValue: '"{\\"id\\":\\"\\",\\"ownerId\\":\\"\\",\\"ownerType\\":\\"\\",\\"period\\":\\"\\",\\"start\\":\\"\\",\\"end\\":\\"\\",\\"actualsComparison\\":[],\\"snapshotAccount\\":[]}"',
          examples: []
        },
        local: {
          schema: "type AccountSnapshotLocalState",
          initialValue: '"{}"',
          examples: []
        }
      },
      modules: [
        {
          id: "3XqsMczWItdBoiPQ/VyXTNNduxA=",
          name: "Snapshot",
          description: "",
          operations: [
            {
              id: "PVeZyYajy8nJe0Y+zRzT+jwSE+Y=",
              name: "SET_ID",
              description: "",
              schema: `input SetIdInput {
    id: ID!
}`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "global"
            },
            {
              id: "AfnDCBOfdGrU+bkibtHuikyJXHY=",
              name: "SET_OWNER_ID",
              description: "",
              schema: `input SetOwnerIdInput {
    ownerId: ID!
}`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "global"
            },
            {
              id: "v3ZXOHRIxLzCaRPU9lYz65Erlnk=",
              name: "SET_OWNER_TYPE",
              description: "",
              schema: `input SetOwnerTypeInput {
    ownerType: String!
}`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "global"
            },
            {
              id: "+ZoYYO2TLmhBnmr03y/lUZ7Pqu0=",
              name: "SET_PERIOD",
              description: "",
              schema: `input SetPeriodInput {
    period: String!
}`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "global"
            },
            {
              id: "XxvmrG51cWoeVFX1qCrH5N7kJwM=",
              name: "SET_START",
              description: "",
              schema: `input SetStartInput {
    start: String!
}`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "global"
            },
            {
              id: "BhYmPnigaKFIA6fASbTvrULfW4U=",
              name: "SET_END",
              description: "",
              schema: `input SetEndInput {
    end: String!
}`,
              template: "",
              reducer: "",
              errors: [],
              examples: [],
              scope: "global"
            }
          ]
        }
      ]
    }
  ]
};
var b;
(function(n) {
  n.assertEqual = (s) => s;
  function e(s) {
  }
  n.assertIs = e;
  function t(s) {
    throw new Error();
  }
  n.assertNever = t, n.arrayToEnum = (s) => {
    const a = {};
    for (const i of s)
      a[i] = i;
    return a;
  }, n.getValidEnumValues = (s) => {
    const a = n.objectKeys(s).filter((o) => typeof s[s[o]] != "number"), i = {};
    for (const o of a)
      i[o] = s[o];
    return n.objectValues(i);
  }, n.objectValues = (s) => n.objectKeys(s).map(function(a) {
    return s[a];
  }), n.objectKeys = typeof Object.keys == "function" ? (s) => Object.keys(s) : (s) => {
    const a = [];
    for (const i in s)
      Object.prototype.hasOwnProperty.call(s, i) && a.push(i);
    return a;
  }, n.find = (s, a) => {
    for (const i of s)
      if (a(i))
        return i;
  }, n.isInteger = typeof Number.isInteger == "function" ? (s) => Number.isInteger(s) : (s) => typeof s == "number" && isFinite(s) && Math.floor(s) === s;
  function r(s, a = " | ") {
    return s.map((i) => typeof i == "string" ? `'${i}'` : i).join(a);
  }
  n.joinValues = r, n.jsonStringifyReplacer = (s, a) => typeof a == "bigint" ? a.toString() : a;
})(b || (b = {}));
var Te;
(function(n) {
  n.mergeShapes = (e, t) => ({
    ...e,
    ...t
    // second overwrites first
  });
})(Te || (Te = {}));
const u = b.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]), j = (n) => {
  switch (typeof n) {
    case "undefined":
      return u.undefined;
    case "string":
      return u.string;
    case "number":
      return isNaN(n) ? u.nan : u.number;
    case "boolean":
      return u.boolean;
    case "function":
      return u.function;
    case "bigint":
      return u.bigint;
    case "symbol":
      return u.symbol;
    case "object":
      return Array.isArray(n) ? u.array : n === null ? u.null : n.then && typeof n.then == "function" && n.catch && typeof n.catch == "function" ? u.promise : typeof Map < "u" && n instanceof Map ? u.map : typeof Set < "u" && n instanceof Set ? u.set : typeof Date < "u" && n instanceof Date ? u.date : u.object;
    default:
      return u.unknown;
  }
}, c = b.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]), ut = (n) => JSON.stringify(n, null, 2).replace(/"([^"]+)":/g, "$1:");
class E extends Error {
  constructor(e) {
    super(), this.issues = [], this.addIssue = (r) => {
      this.issues = [...this.issues, r];
    }, this.addIssues = (r = []) => {
      this.issues = [...this.issues, ...r];
    };
    const t = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, t) : this.__proto__ = t, this.name = "ZodError", this.issues = e;
  }
  get errors() {
    return this.issues;
  }
  format(e) {
    const t = e || function(a) {
      return a.message;
    }, r = { _errors: [] }, s = (a) => {
      for (const i of a.issues)
        if (i.code === "invalid_union")
          i.unionErrors.map(s);
        else if (i.code === "invalid_return_type")
          s(i.returnTypeError);
        else if (i.code === "invalid_arguments")
          s(i.argumentsError);
        else if (i.path.length === 0)
          r._errors.push(t(i));
        else {
          let o = r, h = 0;
          for (; h < i.path.length; ) {
            const d = i.path[h];
            h === i.path.length - 1 ? (o[d] = o[d] || { _errors: [] }, o[d]._errors.push(t(i))) : o[d] = o[d] || { _errors: [] }, o = o[d], h++;
          }
        }
    };
    return s(this), r;
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, b.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (t) => t.message) {
    const t = {}, r = [];
    for (const s of this.issues)
      s.path.length > 0 ? (t[s.path[0]] = t[s.path[0]] || [], t[s.path[0]].push(e(s))) : r.push(e(s));
    return { formErrors: r, fieldErrors: t };
  }
  get formErrors() {
    return this.flatten();
  }
}
E.create = (n) => new E(n);
const J = (n, e) => {
  let t;
  switch (n.code) {
    case c.invalid_type:
      n.received === u.undefined ? t = "Required" : t = `Expected ${n.expected}, received ${n.received}`;
      break;
    case c.invalid_literal:
      t = `Invalid literal value, expected ${JSON.stringify(n.expected, b.jsonStringifyReplacer)}`;
      break;
    case c.unrecognized_keys:
      t = `Unrecognized key(s) in object: ${b.joinValues(n.keys, ", ")}`;
      break;
    case c.invalid_union:
      t = "Invalid input";
      break;
    case c.invalid_union_discriminator:
      t = `Invalid discriminator value. Expected ${b.joinValues(n.options)}`;
      break;
    case c.invalid_enum_value:
      t = `Invalid enum value. Expected ${b.joinValues(n.options)}, received '${n.received}'`;
      break;
    case c.invalid_arguments:
      t = "Invalid function arguments";
      break;
    case c.invalid_return_type:
      t = "Invalid function return type";
      break;
    case c.invalid_date:
      t = "Invalid date";
      break;
    case c.invalid_string:
      typeof n.validation == "object" ? "includes" in n.validation ? (t = `Invalid input: must include "${n.validation.includes}"`, typeof n.validation.position == "number" && (t = `${t} at one or more positions greater than or equal to ${n.validation.position}`)) : "startsWith" in n.validation ? t = `Invalid input: must start with "${n.validation.startsWith}"` : "endsWith" in n.validation ? t = `Invalid input: must end with "${n.validation.endsWith}"` : b.assertNever(n.validation) : n.validation !== "regex" ? t = `Invalid ${n.validation}` : t = "Invalid";
      break;
    case c.too_small:
      n.type === "array" ? t = `Array must contain ${n.exact ? "exactly" : n.inclusive ? "at least" : "more than"} ${n.minimum} element(s)` : n.type === "string" ? t = `String must contain ${n.exact ? "exactly" : n.inclusive ? "at least" : "over"} ${n.minimum} character(s)` : n.type === "number" ? t = `Number must be ${n.exact ? "exactly equal to " : n.inclusive ? "greater than or equal to " : "greater than "}${n.minimum}` : n.type === "date" ? t = `Date must be ${n.exact ? "exactly equal to " : n.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(n.minimum))}` : t = "Invalid input";
      break;
    case c.too_big:
      n.type === "array" ? t = `Array must contain ${n.exact ? "exactly" : n.inclusive ? "at most" : "less than"} ${n.maximum} element(s)` : n.type === "string" ? t = `String must contain ${n.exact ? "exactly" : n.inclusive ? "at most" : "under"} ${n.maximum} character(s)` : n.type === "number" ? t = `Number must be ${n.exact ? "exactly" : n.inclusive ? "less than or equal to" : "less than"} ${n.maximum}` : n.type === "bigint" ? t = `BigInt must be ${n.exact ? "exactly" : n.inclusive ? "less than or equal to" : "less than"} ${n.maximum}` : n.type === "date" ? t = `Date must be ${n.exact ? "exactly" : n.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(n.maximum))}` : t = "Invalid input";
      break;
    case c.custom:
      t = "Invalid input";
      break;
    case c.invalid_intersection_types:
      t = "Intersection results could not be merged";
      break;
    case c.not_multiple_of:
      t = `Number must be a multiple of ${n.multipleOf}`;
      break;
    case c.not_finite:
      t = "Number must be finite";
      break;
    default:
      t = e.defaultError, b.assertNever(n);
  }
  return { message: t };
};
let Le = J;
function lt(n) {
  Le = n;
}
function de() {
  return Le;
}
const ue = (n) => {
  const { data: e, path: t, errorMaps: r, issueData: s } = n, a = [...t, ...s.path || []], i = {
    ...s,
    path: a
  };
  let o = "";
  const h = r.filter((d) => !!d).slice().reverse();
  for (const d of h)
    o = d(i, { data: e, defaultError: o }).message;
  return {
    ...s,
    path: a,
    message: s.message || o
  };
}, pt = [];
function l(n, e) {
  const t = ue({
    issueData: e,
    data: n.data,
    path: n.path,
    errorMaps: [
      n.common.contextualErrorMap,
      n.schemaErrorMap,
      de(),
      J
      // then global default map
    ].filter((r) => !!r)
  });
  n.common.issues.push(t);
}
class k {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, t) {
    const r = [];
    for (const s of t) {
      if (s.status === "aborted")
        return y;
      s.status === "dirty" && e.dirty(), r.push(s.value);
    }
    return { status: e.value, value: r };
  }
  static async mergeObjectAsync(e, t) {
    const r = [];
    for (const s of t)
      r.push({
        key: await s.key,
        value: await s.value
      });
    return k.mergeObjectSync(e, r);
  }
  static mergeObjectSync(e, t) {
    const r = {};
    for (const s of t) {
      const { key: a, value: i } = s;
      if (a.status === "aborted" || i.status === "aborted")
        return y;
      a.status === "dirty" && e.dirty(), i.status === "dirty" && e.dirty(), a.value !== "__proto__" && (typeof i.value < "u" || s.alwaysSet) && (r[a.value] = i.value);
    }
    return { status: e.value, value: r };
  }
}
const y = Object.freeze({
  status: "aborted"
}), $e = (n) => ({ status: "dirty", value: n }), w = (n) => ({ status: "valid", value: n }), Se = (n) => n.status === "aborted", Ee = (n) => n.status === "dirty", X = (n) => n.status === "valid", le = (n) => typeof Promise < "u" && n instanceof Promise;
var f;
(function(n) {
  n.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, n.toString = (e) => typeof e == "string" ? e : e == null ? void 0 : e.message;
})(f || (f = {}));
class Z {
  constructor(e, t, r, s) {
    this._cachedPath = [], this.parent = e, this.data = t, this._path = r, this._key = s;
  }
  get path() {
    return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const De = (n, e) => {
  if (X(e))
    return { success: !0, data: e.value };
  if (!n.common.issues.length)
    throw new Error("Validation failed but no issues detected.");
  return {
    success: !1,
    get error() {
      if (this._error)
        return this._error;
      const t = new E(n.common.issues);
      return this._error = t, this._error;
    }
  };
};
function _(n) {
  if (!n)
    return {};
  const { errorMap: e, invalid_type_error: t, required_error: r, description: s } = n;
  if (e && (t || r))
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: s } : { errorMap: (i, o) => i.code !== "invalid_type" ? { message: o.defaultError } : typeof o.data > "u" ? { message: r ?? o.defaultError } : { message: t ?? o.defaultError }, description: s };
}
class g {
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this);
  }
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return j(e.data);
  }
  _getOrReturnCtx(e, t) {
    return t || {
      common: e.parent.common,
      data: e.data,
      parsedType: j(e.data),
      schemaErrorMap: this._def.errorMap,
      path: e.path,
      parent: e.parent
    };
  }
  _processInputParams(e) {
    return {
      status: new k(),
      ctx: {
        common: e.parent.common,
        data: e.data,
        parsedType: j(e.data),
        schemaErrorMap: this._def.errorMap,
        path: e.path,
        parent: e.parent
      }
    };
  }
  _parseSync(e) {
    const t = this._parse(e);
    if (le(t))
      throw new Error("Synchronous parse encountered promise.");
    return t;
  }
  _parseAsync(e) {
    const t = this._parse(e);
    return Promise.resolve(t);
  }
  parse(e, t) {
    const r = this.safeParse(e, t);
    if (r.success)
      return r.data;
    throw r.error;
  }
  safeParse(e, t) {
    var r;
    const s = {
      common: {
        issues: [],
        async: (r = t == null ? void 0 : t.async) !== null && r !== void 0 ? r : !1,
        contextualErrorMap: t == null ? void 0 : t.errorMap
      },
      path: (t == null ? void 0 : t.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: j(e)
    }, a = this._parseSync({ data: e, path: s.path, parent: s });
    return De(s, a);
  }
  async parseAsync(e, t) {
    const r = await this.safeParseAsync(e, t);
    if (r.success)
      return r.data;
    throw r.error;
  }
  async safeParseAsync(e, t) {
    const r = {
      common: {
        issues: [],
        contextualErrorMap: t == null ? void 0 : t.errorMap,
        async: !0
      },
      path: (t == null ? void 0 : t.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data: e,
      parsedType: j(e)
    }, s = this._parse({ data: e, path: r.path, parent: r }), a = await (le(s) ? s : Promise.resolve(s));
    return De(r, a);
  }
  refine(e, t) {
    const r = (s) => typeof t == "string" || typeof t > "u" ? { message: t } : typeof t == "function" ? t(s) : t;
    return this._refinement((s, a) => {
      const i = e(s), o = () => a.addIssue({
        code: c.custom,
        ...r(s)
      });
      return typeof Promise < "u" && i instanceof Promise ? i.then((h) => h ? !0 : (o(), !1)) : i ? !0 : (o(), !1);
    });
  }
  refinement(e, t) {
    return this._refinement((r, s) => e(r) ? !0 : (s.addIssue(typeof t == "function" ? t(r, s) : t), !1));
  }
  _refinement(e) {
    return new O({
      schema: this,
      typeName: m.ZodEffects,
      effect: { type: "refinement", refinement: e }
    });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  optional() {
    return A.create(this, this._def);
  }
  nullable() {
    return z.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return I.create(this, this._def);
  }
  promise() {
    return q.create(this, this._def);
  }
  or(e) {
    return ee.create([this, e], this._def);
  }
  and(e) {
    return te.create(this, e, this._def);
  }
  transform(e) {
    return new O({
      ..._(this._def),
      schema: this,
      typeName: m.ZodEffects,
      effect: { type: "transform", transform: e }
    });
  }
  default(e) {
    const t = typeof e == "function" ? e : () => e;
    return new ie({
      ..._(this._def),
      innerType: this,
      defaultValue: t,
      typeName: m.ZodDefault
    });
  }
  brand() {
    return new Be({
      typeName: m.ZodBranded,
      type: this,
      ..._(this._def)
    });
  }
  catch(e) {
    const t = typeof e == "function" ? e : () => e;
    return new me({
      ..._(this._def),
      innerType: this,
      catchValue: t,
      typeName: m.ZodCatch
    });
  }
  describe(e) {
    const t = this.constructor;
    return new t({
      ...this._def,
      description: e
    });
  }
  pipe(e) {
    return oe.create(this, e);
  }
  readonly() {
    return _e.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const ht = /^c[^\s-]{8,}$/i, ft = /^[a-z][a-z0-9]*$/, mt = /^[0-9A-HJKMNP-TV-Z]{26}$/, yt = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, _t = /^(?!\.)(?!.*\.\.)([A-Z0-9_+-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, gt = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
let we;
const vt = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/, bt = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/, xt = (n) => n.precision ? n.offset ? new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${n.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`) : new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${n.precision}}Z$`) : n.precision === 0 ? n.offset ? new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$") : new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$") : n.offset ? new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$") : new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$");
function kt(n, e) {
  return !!((e === "v4" || !e) && vt.test(n) || (e === "v6" || !e) && bt.test(n));
}
class S extends g {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== u.string) {
      const a = this._getOrReturnCtx(e);
      return l(
        a,
        {
          code: c.invalid_type,
          expected: u.string,
          received: a.parsedType
        }
        //
      ), y;
    }
    const r = new k();
    let s;
    for (const a of this._def.checks)
      if (a.kind === "min")
        e.data.length < a.value && (s = this._getOrReturnCtx(e, s), l(s, {
          code: c.too_small,
          minimum: a.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: a.message
        }), r.dirty());
      else if (a.kind === "max")
        e.data.length > a.value && (s = this._getOrReturnCtx(e, s), l(s, {
          code: c.too_big,
          maximum: a.value,
          type: "string",
          inclusive: !0,
          exact: !1,
          message: a.message
        }), r.dirty());
      else if (a.kind === "length") {
        const i = e.data.length > a.value, o = e.data.length < a.value;
        (i || o) && (s = this._getOrReturnCtx(e, s), i ? l(s, {
          code: c.too_big,
          maximum: a.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: a.message
        }) : o && l(s, {
          code: c.too_small,
          minimum: a.value,
          type: "string",
          inclusive: !0,
          exact: !0,
          message: a.message
        }), r.dirty());
      } else if (a.kind === "email")
        _t.test(e.data) || (s = this._getOrReturnCtx(e, s), l(s, {
          validation: "email",
          code: c.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "emoji")
        we || (we = new RegExp(gt, "u")), we.test(e.data) || (s = this._getOrReturnCtx(e, s), l(s, {
          validation: "emoji",
          code: c.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "uuid")
        yt.test(e.data) || (s = this._getOrReturnCtx(e, s), l(s, {
          validation: "uuid",
          code: c.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "cuid")
        ht.test(e.data) || (s = this._getOrReturnCtx(e, s), l(s, {
          validation: "cuid",
          code: c.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "cuid2")
        ft.test(e.data) || (s = this._getOrReturnCtx(e, s), l(s, {
          validation: "cuid2",
          code: c.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "ulid")
        mt.test(e.data) || (s = this._getOrReturnCtx(e, s), l(s, {
          validation: "ulid",
          code: c.invalid_string,
          message: a.message
        }), r.dirty());
      else if (a.kind === "url")
        try {
          new URL(e.data);
        } catch {
          s = this._getOrReturnCtx(e, s), l(s, {
            validation: "url",
            code: c.invalid_string,
            message: a.message
          }), r.dirty();
        }
      else
        a.kind === "regex" ? (a.regex.lastIndex = 0, a.regex.test(e.data) || (s = this._getOrReturnCtx(e, s), l(s, {
          validation: "regex",
          code: c.invalid_string,
          message: a.message
        }), r.dirty())) : a.kind === "trim" ? e.data = e.data.trim() : a.kind === "includes" ? e.data.includes(a.value, a.position) || (s = this._getOrReturnCtx(e, s), l(s, {
          code: c.invalid_string,
          validation: { includes: a.value, position: a.position },
          message: a.message
        }), r.dirty()) : a.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : a.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : a.kind === "startsWith" ? e.data.startsWith(a.value) || (s = this._getOrReturnCtx(e, s), l(s, {
          code: c.invalid_string,
          validation: { startsWith: a.value },
          message: a.message
        }), r.dirty()) : a.kind === "endsWith" ? e.data.endsWith(a.value) || (s = this._getOrReturnCtx(e, s), l(s, {
          code: c.invalid_string,
          validation: { endsWith: a.value },
          message: a.message
        }), r.dirty()) : a.kind === "datetime" ? xt(a).test(e.data) || (s = this._getOrReturnCtx(e, s), l(s, {
          code: c.invalid_string,
          validation: "datetime",
          message: a.message
        }), r.dirty()) : a.kind === "ip" ? kt(e.data, a.version) || (s = this._getOrReturnCtx(e, s), l(s, {
          validation: "ip",
          code: c.invalid_string,
          message: a.message
        }), r.dirty()) : b.assertNever(a);
    return { status: r.value, value: e.data };
  }
  _regex(e, t, r) {
    return this.refinement((s) => e.test(s), {
      validation: t,
      code: c.invalid_string,
      ...f.errToObj(r)
    });
  }
  _addCheck(e) {
    return new S({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...f.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...f.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...f.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...f.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...f.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...f.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...f.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...f.errToObj(e) });
  }
  datetime(e) {
    var t;
    return typeof e == "string" ? this._addCheck({
      kind: "datetime",
      precision: null,
      offset: !1,
      message: e
    }) : this._addCheck({
      kind: "datetime",
      precision: typeof (e == null ? void 0 : e.precision) > "u" ? null : e == null ? void 0 : e.precision,
      offset: (t = e == null ? void 0 : e.offset) !== null && t !== void 0 ? t : !1,
      ...f.errToObj(e == null ? void 0 : e.message)
    });
  }
  regex(e, t) {
    return this._addCheck({
      kind: "regex",
      regex: e,
      ...f.errToObj(t)
    });
  }
  includes(e, t) {
    return this._addCheck({
      kind: "includes",
      value: e,
      position: t == null ? void 0 : t.position,
      ...f.errToObj(t == null ? void 0 : t.message)
    });
  }
  startsWith(e, t) {
    return this._addCheck({
      kind: "startsWith",
      value: e,
      ...f.errToObj(t)
    });
  }
  endsWith(e, t) {
    return this._addCheck({
      kind: "endsWith",
      value: e,
      ...f.errToObj(t)
    });
  }
  min(e, t) {
    return this._addCheck({
      kind: "min",
      value: e,
      ...f.errToObj(t)
    });
  }
  max(e, t) {
    return this._addCheck({
      kind: "max",
      value: e,
      ...f.errToObj(t)
    });
  }
  length(e, t) {
    return this._addCheck({
      kind: "length",
      value: e,
      ...f.errToObj(t)
    });
  }
  /**
   * @deprecated Use z.string().min(1) instead.
   * @see {@link ZodString.min}
   */
  nonempty(e) {
    return this.min(1, f.errToObj(e));
  }
  trim() {
    return new S({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
  }
  toLowerCase() {
    return new S({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
  }
  toUpperCase() {
    return new S({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get minLength() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "min" && (e === null || t.value > e) && (e = t.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "max" && (e === null || t.value < e) && (e = t.value);
    return e;
  }
}
S.create = (n) => {
  var e;
  return new S({
    checks: [],
    typeName: m.ZodString,
    coerce: (e = n == null ? void 0 : n.coerce) !== null && e !== void 0 ? e : !1,
    ..._(n)
  });
};
function wt(n, e) {
  const t = (n.toString().split(".")[1] || "").length, r = (e.toString().split(".")[1] || "").length, s = t > r ? t : r, a = parseInt(n.toFixed(s).replace(".", "")), i = parseInt(e.toFixed(s).replace(".", ""));
  return a % i / Math.pow(10, s);
}
class P extends g {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== u.number) {
      const a = this._getOrReturnCtx(e);
      return l(a, {
        code: c.invalid_type,
        expected: u.number,
        received: a.parsedType
      }), y;
    }
    let r;
    const s = new k();
    for (const a of this._def.checks)
      a.kind === "int" ? b.isInteger(e.data) || (r = this._getOrReturnCtx(e, r), l(r, {
        code: c.invalid_type,
        expected: "integer",
        received: "float",
        message: a.message
      }), s.dirty()) : a.kind === "min" ? (a.inclusive ? e.data < a.value : e.data <= a.value) && (r = this._getOrReturnCtx(e, r), l(r, {
        code: c.too_small,
        minimum: a.value,
        type: "number",
        inclusive: a.inclusive,
        exact: !1,
        message: a.message
      }), s.dirty()) : a.kind === "max" ? (a.inclusive ? e.data > a.value : e.data >= a.value) && (r = this._getOrReturnCtx(e, r), l(r, {
        code: c.too_big,
        maximum: a.value,
        type: "number",
        inclusive: a.inclusive,
        exact: !1,
        message: a.message
      }), s.dirty()) : a.kind === "multipleOf" ? wt(e.data, a.value) !== 0 && (r = this._getOrReturnCtx(e, r), l(r, {
        code: c.not_multiple_of,
        multipleOf: a.value,
        message: a.message
      }), s.dirty()) : a.kind === "finite" ? Number.isFinite(e.data) || (r = this._getOrReturnCtx(e, r), l(r, {
        code: c.not_finite,
        message: a.message
      }), s.dirty()) : b.assertNever(a);
    return { status: s.value, value: e.data };
  }
  gte(e, t) {
    return this.setLimit("min", e, !0, f.toString(t));
  }
  gt(e, t) {
    return this.setLimit("min", e, !1, f.toString(t));
  }
  lte(e, t) {
    return this.setLimit("max", e, !0, f.toString(t));
  }
  lt(e, t) {
    return this.setLimit("max", e, !1, f.toString(t));
  }
  setLimit(e, t, r, s) {
    return new P({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: t,
          inclusive: r,
          message: f.toString(s)
        }
      ]
    });
  }
  _addCheck(e) {
    return new P({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  int(e) {
    return this._addCheck({
      kind: "int",
      message: f.toString(e)
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !1,
      message: f.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !1,
      message: f.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: !0,
      message: f.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: !0,
      message: f.toString(e)
    });
  }
  multipleOf(e, t) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: f.toString(t)
    });
  }
  finite(e) {
    return this._addCheck({
      kind: "finite",
      message: f.toString(e)
    });
  }
  safe(e) {
    return this._addCheck({
      kind: "min",
      inclusive: !0,
      value: Number.MIN_SAFE_INTEGER,
      message: f.toString(e)
    })._addCheck({
      kind: "max",
      inclusive: !0,
      value: Number.MAX_SAFE_INTEGER,
      message: f.toString(e)
    });
  }
  get minValue() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "min" && (e === null || t.value > e) && (e = t.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "max" && (e === null || t.value < e) && (e = t.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && b.isInteger(e.value));
  }
  get isFinite() {
    let e = null, t = null;
    for (const r of this._def.checks) {
      if (r.kind === "finite" || r.kind === "int" || r.kind === "multipleOf")
        return !0;
      r.kind === "min" ? (t === null || r.value > t) && (t = r.value) : r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    }
    return Number.isFinite(t) && Number.isFinite(e);
  }
}
P.create = (n) => new P({
  checks: [],
  typeName: m.ZodNumber,
  coerce: (n == null ? void 0 : n.coerce) || !1,
  ..._(n)
});
class D extends g {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = BigInt(e.data)), this._getType(e) !== u.bigint) {
      const a = this._getOrReturnCtx(e);
      return l(a, {
        code: c.invalid_type,
        expected: u.bigint,
        received: a.parsedType
      }), y;
    }
    let r;
    const s = new k();
    for (const a of this._def.checks)
      a.kind === "min" ? (a.inclusive ? e.data < a.value : e.data <= a.value) && (r = this._getOrReturnCtx(e, r), l(r, {
        code: c.too_small,
        type: "bigint",
        minimum: a.value,
        inclusive: a.inclusive,
        message: a.message
      }), s.dirty()) : a.kind === "max" ? (a.inclusive ? e.data > a.value : e.data >= a.value) && (r = this._getOrReturnCtx(e, r), l(r, {
        code: c.too_big,
        type: "bigint",
        maximum: a.value,
        inclusive: a.inclusive,
        message: a.message
      }), s.dirty()) : a.kind === "multipleOf" ? e.data % a.value !== BigInt(0) && (r = this._getOrReturnCtx(e, r), l(r, {
        code: c.not_multiple_of,
        multipleOf: a.value,
        message: a.message
      }), s.dirty()) : b.assertNever(a);
    return { status: s.value, value: e.data };
  }
  gte(e, t) {
    return this.setLimit("min", e, !0, f.toString(t));
  }
  gt(e, t) {
    return this.setLimit("min", e, !1, f.toString(t));
  }
  lte(e, t) {
    return this.setLimit("max", e, !0, f.toString(t));
  }
  lt(e, t) {
    return this.setLimit("max", e, !1, f.toString(t));
  }
  setLimit(e, t, r, s) {
    return new D({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind: e,
          value: t,
          inclusive: r,
          message: f.toString(s)
        }
      ]
    });
  }
  _addCheck(e) {
    return new D({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  positive(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !1,
      message: f.toString(e)
    });
  }
  negative(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !1,
      message: f.toString(e)
    });
  }
  nonpositive(e) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: !0,
      message: f.toString(e)
    });
  }
  nonnegative(e) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: !0,
      message: f.toString(e)
    });
  }
  multipleOf(e, t) {
    return this._addCheck({
      kind: "multipleOf",
      value: e,
      message: f.toString(t)
    });
  }
  get minValue() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "min" && (e === null || t.value > e) && (e = t.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "max" && (e === null || t.value < e) && (e = t.value);
    return e;
  }
}
D.create = (n) => {
  var e;
  return new D({
    checks: [],
    typeName: m.ZodBigInt,
    coerce: (e = n == null ? void 0 : n.coerce) !== null && e !== void 0 ? e : !1,
    ..._(n)
  });
};
class G extends g {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== u.boolean) {
      const r = this._getOrReturnCtx(e);
      return l(r, {
        code: c.invalid_type,
        expected: u.boolean,
        received: r.parsedType
      }), y;
    }
    return w(e.data);
  }
}
G.create = (n) => new G({
  typeName: m.ZodBoolean,
  coerce: (n == null ? void 0 : n.coerce) || !1,
  ..._(n)
});
class L extends g {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== u.date) {
      const a = this._getOrReturnCtx(e);
      return l(a, {
        code: c.invalid_type,
        expected: u.date,
        received: a.parsedType
      }), y;
    }
    if (isNaN(e.data.getTime())) {
      const a = this._getOrReturnCtx(e);
      return l(a, {
        code: c.invalid_date
      }), y;
    }
    const r = new k();
    let s;
    for (const a of this._def.checks)
      a.kind === "min" ? e.data.getTime() < a.value && (s = this._getOrReturnCtx(e, s), l(s, {
        code: c.too_small,
        message: a.message,
        inclusive: !0,
        exact: !1,
        minimum: a.value,
        type: "date"
      }), r.dirty()) : a.kind === "max" ? e.data.getTime() > a.value && (s = this._getOrReturnCtx(e, s), l(s, {
        code: c.too_big,
        message: a.message,
        inclusive: !0,
        exact: !1,
        maximum: a.value,
        type: "date"
      }), r.dirty()) : b.assertNever(a);
    return {
      status: r.value,
      value: new Date(e.data.getTime())
    };
  }
  _addCheck(e) {
    return new L({
      ...this._def,
      checks: [...this._def.checks, e]
    });
  }
  min(e, t) {
    return this._addCheck({
      kind: "min",
      value: e.getTime(),
      message: f.toString(t)
    });
  }
  max(e, t) {
    return this._addCheck({
      kind: "max",
      value: e.getTime(),
      message: f.toString(t)
    });
  }
  get minDate() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "min" && (e === null || t.value > e) && (e = t.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const t of this._def.checks)
      t.kind === "max" && (e === null || t.value < e) && (e = t.value);
    return e != null ? new Date(e) : null;
  }
}
L.create = (n) => new L({
  checks: [],
  coerce: (n == null ? void 0 : n.coerce) || !1,
  typeName: m.ZodDate,
  ..._(n)
});
class pe extends g {
  _parse(e) {
    if (this._getType(e) !== u.symbol) {
      const r = this._getOrReturnCtx(e);
      return l(r, {
        code: c.invalid_type,
        expected: u.symbol,
        received: r.parsedType
      }), y;
    }
    return w(e.data);
  }
}
pe.create = (n) => new pe({
  typeName: m.ZodSymbol,
  ..._(n)
});
class Q extends g {
  _parse(e) {
    if (this._getType(e) !== u.undefined) {
      const r = this._getOrReturnCtx(e);
      return l(r, {
        code: c.invalid_type,
        expected: u.undefined,
        received: r.parsedType
      }), y;
    }
    return w(e.data);
  }
}
Q.create = (n) => new Q({
  typeName: m.ZodUndefined,
  ..._(n)
});
class K extends g {
  _parse(e) {
    if (this._getType(e) !== u.null) {
      const r = this._getOrReturnCtx(e);
      return l(r, {
        code: c.invalid_type,
        expected: u.null,
        received: r.parsedType
      }), y;
    }
    return w(e.data);
  }
}
K.create = (n) => new K({
  typeName: m.ZodNull,
  ..._(n)
});
class F extends g {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return w(e.data);
  }
}
F.create = (n) => new F({
  typeName: m.ZodAny,
  ..._(n)
});
class V extends g {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return w(e.data);
  }
}
V.create = (n) => new V({
  typeName: m.ZodUnknown,
  ..._(n)
});
class R extends g {
  _parse(e) {
    const t = this._getOrReturnCtx(e);
    return l(t, {
      code: c.invalid_type,
      expected: u.never,
      received: t.parsedType
    }), y;
  }
}
R.create = (n) => new R({
  typeName: m.ZodNever,
  ..._(n)
});
class he extends g {
  _parse(e) {
    if (this._getType(e) !== u.undefined) {
      const r = this._getOrReturnCtx(e);
      return l(r, {
        code: c.invalid_type,
        expected: u.void,
        received: r.parsedType
      }), y;
    }
    return w(e.data);
  }
}
he.create = (n) => new he({
  typeName: m.ZodVoid,
  ..._(n)
});
class I extends g {
  _parse(e) {
    const { ctx: t, status: r } = this._processInputParams(e), s = this._def;
    if (t.parsedType !== u.array)
      return l(t, {
        code: c.invalid_type,
        expected: u.array,
        received: t.parsedType
      }), y;
    if (s.exactLength !== null) {
      const i = t.data.length > s.exactLength.value, o = t.data.length < s.exactLength.value;
      (i || o) && (l(t, {
        code: i ? c.too_big : c.too_small,
        minimum: o ? s.exactLength.value : void 0,
        maximum: i ? s.exactLength.value : void 0,
        type: "array",
        inclusive: !0,
        exact: !0,
        message: s.exactLength.message
      }), r.dirty());
    }
    if (s.minLength !== null && t.data.length < s.minLength.value && (l(t, {
      code: c.too_small,
      minimum: s.minLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: s.minLength.message
    }), r.dirty()), s.maxLength !== null && t.data.length > s.maxLength.value && (l(t, {
      code: c.too_big,
      maximum: s.maxLength.value,
      type: "array",
      inclusive: !0,
      exact: !1,
      message: s.maxLength.message
    }), r.dirty()), t.common.async)
      return Promise.all([...t.data].map((i, o) => s.type._parseAsync(new Z(t, i, t.path, o)))).then((i) => k.mergeArray(r, i));
    const a = [...t.data].map((i, o) => s.type._parseSync(new Z(t, i, t.path, o)));
    return k.mergeArray(r, a);
  }
  get element() {
    return this._def.type;
  }
  min(e, t) {
    return new I({
      ...this._def,
      minLength: { value: e, message: f.toString(t) }
    });
  }
  max(e, t) {
    return new I({
      ...this._def,
      maxLength: { value: e, message: f.toString(t) }
    });
  }
  length(e, t) {
    return new I({
      ...this._def,
      exactLength: { value: e, message: f.toString(t) }
    });
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
I.create = (n, e) => new I({
  type: n,
  minLength: null,
  maxLength: null,
  exactLength: null,
  typeName: m.ZodArray,
  ..._(e)
});
function U(n) {
  if (n instanceof x) {
    const e = {};
    for (const t in n.shape) {
      const r = n.shape[t];
      e[t] = A.create(U(r));
    }
    return new x({
      ...n._def,
      shape: () => e
    });
  } else
    return n instanceof I ? new I({
      ...n._def,
      type: U(n.element)
    }) : n instanceof A ? A.create(U(n.unwrap())) : n instanceof z ? z.create(U(n.unwrap())) : n instanceof N ? N.create(n.items.map((e) => U(e))) : n;
}
class x extends g {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const e = this._def.shape(), t = b.objectKeys(e);
    return this._cached = { shape: e, keys: t };
  }
  _parse(e) {
    if (this._getType(e) !== u.object) {
      const d = this._getOrReturnCtx(e);
      return l(d, {
        code: c.invalid_type,
        expected: u.object,
        received: d.parsedType
      }), y;
    }
    const { status: r, ctx: s } = this._processInputParams(e), { shape: a, keys: i } = this._getCached(), o = [];
    if (!(this._def.catchall instanceof R && this._def.unknownKeys === "strip"))
      for (const d in s.data)
        i.includes(d) || o.push(d);
    const h = [];
    for (const d of i) {
      const v = a[d], T = s.data[d];
      h.push({
        key: { status: "valid", value: d },
        value: v._parse(new Z(s, T, s.path, d)),
        alwaysSet: d in s.data
      });
    }
    if (this._def.catchall instanceof R) {
      const d = this._def.unknownKeys;
      if (d === "passthrough")
        for (const v of o)
          h.push({
            key: { status: "valid", value: v },
            value: { status: "valid", value: s.data[v] }
          });
      else if (d === "strict")
        o.length > 0 && (l(s, {
          code: c.unrecognized_keys,
          keys: o
        }), r.dirty());
      else if (d !== "strip")
        throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const d = this._def.catchall;
      for (const v of o) {
        const T = s.data[v];
        h.push({
          key: { status: "valid", value: v },
          value: d._parse(
            new Z(s, T, s.path, v)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: v in s.data
        });
      }
    }
    return s.common.async ? Promise.resolve().then(async () => {
      const d = [];
      for (const v of h) {
        const T = await v.key;
        d.push({
          key: T,
          value: await v.value,
          alwaysSet: v.alwaysSet
        });
      }
      return d;
    }).then((d) => k.mergeObjectSync(r, d)) : k.mergeObjectSync(r, h);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return f.errToObj, new x({
      ...this._def,
      unknownKeys: "strict",
      ...e !== void 0 ? {
        errorMap: (t, r) => {
          var s, a, i, o;
          const h = (i = (a = (s = this._def).errorMap) === null || a === void 0 ? void 0 : a.call(s, t, r).message) !== null && i !== void 0 ? i : r.defaultError;
          return t.code === "unrecognized_keys" ? {
            message: (o = f.errToObj(e).message) !== null && o !== void 0 ? o : h
          } : {
            message: h
          };
        }
      } : {}
    });
  }
  strip() {
    return new x({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new x({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(e) {
    return new x({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...e
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(e) {
    return new x({
      unknownKeys: e._def.unknownKeys,
      catchall: e._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...e._def.shape()
      }),
      typeName: m.ZodObject
    });
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(e, t) {
    return this.augment({ [e]: t });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(e) {
    return new x({
      ...this._def,
      catchall: e
    });
  }
  pick(e) {
    const t = {};
    return b.objectKeys(e).forEach((r) => {
      e[r] && this.shape[r] && (t[r] = this.shape[r]);
    }), new x({
      ...this._def,
      shape: () => t
    });
  }
  omit(e) {
    const t = {};
    return b.objectKeys(this.shape).forEach((r) => {
      e[r] || (t[r] = this.shape[r]);
    }), new x({
      ...this._def,
      shape: () => t
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return U(this);
  }
  partial(e) {
    const t = {};
    return b.objectKeys(this.shape).forEach((r) => {
      const s = this.shape[r];
      e && !e[r] ? t[r] = s : t[r] = s.optional();
    }), new x({
      ...this._def,
      shape: () => t
    });
  }
  required(e) {
    const t = {};
    return b.objectKeys(this.shape).forEach((r) => {
      if (e && !e[r])
        t[r] = this.shape[r];
      else {
        let a = this.shape[r];
        for (; a instanceof A; )
          a = a._def.innerType;
        t[r] = a;
      }
    }), new x({
      ...this._def,
      shape: () => t
    });
  }
  keyof() {
    return ze(b.objectKeys(this.shape));
  }
}
x.create = (n, e) => new x({
  shape: () => n,
  unknownKeys: "strip",
  catchall: R.create(),
  typeName: m.ZodObject,
  ..._(e)
});
x.strictCreate = (n, e) => new x({
  shape: () => n,
  unknownKeys: "strict",
  catchall: R.create(),
  typeName: m.ZodObject,
  ..._(e)
});
x.lazycreate = (n, e) => new x({
  shape: n,
  unknownKeys: "strip",
  catchall: R.create(),
  typeName: m.ZodObject,
  ..._(e)
});
class ee extends g {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e), r = this._def.options;
    function s(a) {
      for (const o of a)
        if (o.result.status === "valid")
          return o.result;
      for (const o of a)
        if (o.result.status === "dirty")
          return t.common.issues.push(...o.ctx.common.issues), o.result;
      const i = a.map((o) => new E(o.ctx.common.issues));
      return l(t, {
        code: c.invalid_union,
        unionErrors: i
      }), y;
    }
    if (t.common.async)
      return Promise.all(r.map(async (a) => {
        const i = {
          ...t,
          common: {
            ...t.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await a._parseAsync({
            data: t.data,
            path: t.path,
            parent: i
          }),
          ctx: i
        };
      })).then(s);
    {
      let a;
      const i = [];
      for (const h of r) {
        const d = {
          ...t,
          common: {
            ...t.common,
            issues: []
          },
          parent: null
        }, v = h._parseSync({
          data: t.data,
          path: t.path,
          parent: d
        });
        if (v.status === "valid")
          return v;
        v.status === "dirty" && !a && (a = { result: v, ctx: d }), d.common.issues.length && i.push(d.common.issues);
      }
      if (a)
        return t.common.issues.push(...a.ctx.common.issues), a.result;
      const o = i.map((h) => new E(h));
      return l(t, {
        code: c.invalid_union,
        unionErrors: o
      }), y;
    }
  }
  get options() {
    return this._def.options;
  }
}
ee.create = (n, e) => new ee({
  options: n,
  typeName: m.ZodUnion,
  ..._(e)
});
const ce = (n) => n instanceof re ? ce(n.schema) : n instanceof O ? ce(n.innerType()) : n instanceof se ? [n.value] : n instanceof M ? n.options : n instanceof ae ? Object.keys(n.enum) : n instanceof ie ? ce(n._def.innerType) : n instanceof Q ? [void 0] : n instanceof K ? [null] : null;
class xe extends g {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    if (t.parsedType !== u.object)
      return l(t, {
        code: c.invalid_type,
        expected: u.object,
        received: t.parsedType
      }), y;
    const r = this.discriminator, s = t.data[r], a = this.optionsMap.get(s);
    return a ? t.common.async ? a._parseAsync({
      data: t.data,
      path: t.path,
      parent: t
    }) : a._parseSync({
      data: t.data,
      path: t.path,
      parent: t
    }) : (l(t, {
      code: c.invalid_union_discriminator,
      options: Array.from(this.optionsMap.keys()),
      path: [r]
    }), y);
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(e, t, r) {
    const s = /* @__PURE__ */ new Map();
    for (const a of t) {
      const i = ce(a.shape[e]);
      if (!i)
        throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);
      for (const o of i) {
        if (s.has(o))
          throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(o)}`);
        s.set(o, a);
      }
    }
    return new xe({
      typeName: m.ZodDiscriminatedUnion,
      discriminator: e,
      options: t,
      optionsMap: s,
      ..._(r)
    });
  }
}
function Ie(n, e) {
  const t = j(n), r = j(e);
  if (n === e)
    return { valid: !0, data: n };
  if (t === u.object && r === u.object) {
    const s = b.objectKeys(e), a = b.objectKeys(n).filter((o) => s.indexOf(o) !== -1), i = { ...n, ...e };
    for (const o of a) {
      const h = Ie(n[o], e[o]);
      if (!h.valid)
        return { valid: !1 };
      i[o] = h.data;
    }
    return { valid: !0, data: i };
  } else if (t === u.array && r === u.array) {
    if (n.length !== e.length)
      return { valid: !1 };
    const s = [];
    for (let a = 0; a < n.length; a++) {
      const i = n[a], o = e[a], h = Ie(i, o);
      if (!h.valid)
        return { valid: !1 };
      s.push(h.data);
    }
    return { valid: !0, data: s };
  } else
    return t === u.date && r === u.date && +n == +e ? { valid: !0, data: n } : { valid: !1 };
}
class te extends g {
  _parse(e) {
    const { status: t, ctx: r } = this._processInputParams(e), s = (a, i) => {
      if (Se(a) || Se(i))
        return y;
      const o = Ie(a.value, i.value);
      return o.valid ? ((Ee(a) || Ee(i)) && t.dirty(), { status: t.value, value: o.data }) : (l(r, {
        code: c.invalid_intersection_types
      }), y);
    };
    return r.common.async ? Promise.all([
      this._def.left._parseAsync({
        data: r.data,
        path: r.path,
        parent: r
      }),
      this._def.right._parseAsync({
        data: r.data,
        path: r.path,
        parent: r
      })
    ]).then(([a, i]) => s(a, i)) : s(this._def.left._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }), this._def.right._parseSync({
      data: r.data,
      path: r.path,
      parent: r
    }));
  }
}
te.create = (n, e, t) => new te({
  left: n,
  right: e,
  typeName: m.ZodIntersection,
  ..._(t)
});
class N extends g {
  _parse(e) {
    const { status: t, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== u.array)
      return l(r, {
        code: c.invalid_type,
        expected: u.array,
        received: r.parsedType
      }), y;
    if (r.data.length < this._def.items.length)
      return l(r, {
        code: c.too_small,
        minimum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), y;
    !this._def.rest && r.data.length > this._def.items.length && (l(r, {
      code: c.too_big,
      maximum: this._def.items.length,
      inclusive: !0,
      exact: !1,
      type: "array"
    }), t.dirty());
    const a = [...r.data].map((i, o) => {
      const h = this._def.items[o] || this._def.rest;
      return h ? h._parse(new Z(r, i, r.path, o)) : null;
    }).filter((i) => !!i);
    return r.common.async ? Promise.all(a).then((i) => k.mergeArray(t, i)) : k.mergeArray(t, a);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new N({
      ...this._def,
      rest: e
    });
  }
}
N.create = (n, e) => {
  if (!Array.isArray(n))
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new N({
    items: n,
    typeName: m.ZodTuple,
    rest: null,
    ..._(e)
  });
};
class ne extends g {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: t, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== u.object)
      return l(r, {
        code: c.invalid_type,
        expected: u.object,
        received: r.parsedType
      }), y;
    const s = [], a = this._def.keyType, i = this._def.valueType;
    for (const o in r.data)
      s.push({
        key: a._parse(new Z(r, o, r.path, o)),
        value: i._parse(new Z(r, r.data[o], r.path, o))
      });
    return r.common.async ? k.mergeObjectAsync(t, s) : k.mergeObjectSync(t, s);
  }
  get element() {
    return this._def.valueType;
  }
  static create(e, t, r) {
    return t instanceof g ? new ne({
      keyType: e,
      valueType: t,
      typeName: m.ZodRecord,
      ..._(r)
    }) : new ne({
      keyType: S.create(),
      valueType: e,
      typeName: m.ZodRecord,
      ..._(t)
    });
  }
}
class fe extends g {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: t, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== u.map)
      return l(r, {
        code: c.invalid_type,
        expected: u.map,
        received: r.parsedType
      }), y;
    const s = this._def.keyType, a = this._def.valueType, i = [...r.data.entries()].map(([o, h], d) => ({
      key: s._parse(new Z(r, o, r.path, [d, "key"])),
      value: a._parse(new Z(r, h, r.path, [d, "value"]))
    }));
    if (r.common.async) {
      const o = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const h of i) {
          const d = await h.key, v = await h.value;
          if (d.status === "aborted" || v.status === "aborted")
            return y;
          (d.status === "dirty" || v.status === "dirty") && t.dirty(), o.set(d.value, v.value);
        }
        return { status: t.value, value: o };
      });
    } else {
      const o = /* @__PURE__ */ new Map();
      for (const h of i) {
        const d = h.key, v = h.value;
        if (d.status === "aborted" || v.status === "aborted")
          return y;
        (d.status === "dirty" || v.status === "dirty") && t.dirty(), o.set(d.value, v.value);
      }
      return { status: t.value, value: o };
    }
  }
}
fe.create = (n, e, t) => new fe({
  valueType: e,
  keyType: n,
  typeName: m.ZodMap,
  ..._(t)
});
class $ extends g {
  _parse(e) {
    const { status: t, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== u.set)
      return l(r, {
        code: c.invalid_type,
        expected: u.set,
        received: r.parsedType
      }), y;
    const s = this._def;
    s.minSize !== null && r.data.size < s.minSize.value && (l(r, {
      code: c.too_small,
      minimum: s.minSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: s.minSize.message
    }), t.dirty()), s.maxSize !== null && r.data.size > s.maxSize.value && (l(r, {
      code: c.too_big,
      maximum: s.maxSize.value,
      type: "set",
      inclusive: !0,
      exact: !1,
      message: s.maxSize.message
    }), t.dirty());
    const a = this._def.valueType;
    function i(h) {
      const d = /* @__PURE__ */ new Set();
      for (const v of h) {
        if (v.status === "aborted")
          return y;
        v.status === "dirty" && t.dirty(), d.add(v.value);
      }
      return { status: t.value, value: d };
    }
    const o = [...r.data.values()].map((h, d) => a._parse(new Z(r, h, r.path, d)));
    return r.common.async ? Promise.all(o).then((h) => i(h)) : i(o);
  }
  min(e, t) {
    return new $({
      ...this._def,
      minSize: { value: e, message: f.toString(t) }
    });
  }
  max(e, t) {
    return new $({
      ...this._def,
      maxSize: { value: e, message: f.toString(t) }
    });
  }
  size(e, t) {
    return this.min(e, t).max(e, t);
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
$.create = (n, e) => new $({
  valueType: n,
  minSize: null,
  maxSize: null,
  typeName: m.ZodSet,
  ..._(e)
});
class W extends g {
  constructor() {
    super(...arguments), this.validate = this.implement;
  }
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    if (t.parsedType !== u.function)
      return l(t, {
        code: c.invalid_type,
        expected: u.function,
        received: t.parsedType
      }), y;
    function r(o, h) {
      return ue({
        data: o,
        path: t.path,
        errorMaps: [
          t.common.contextualErrorMap,
          t.schemaErrorMap,
          de(),
          J
        ].filter((d) => !!d),
        issueData: {
          code: c.invalid_arguments,
          argumentsError: h
        }
      });
    }
    function s(o, h) {
      return ue({
        data: o,
        path: t.path,
        errorMaps: [
          t.common.contextualErrorMap,
          t.schemaErrorMap,
          de(),
          J
        ].filter((d) => !!d),
        issueData: {
          code: c.invalid_return_type,
          returnTypeError: h
        }
      });
    }
    const a = { errorMap: t.common.contextualErrorMap }, i = t.data;
    if (this._def.returns instanceof q) {
      const o = this;
      return w(async function(...h) {
        const d = new E([]), v = await o._def.args.parseAsync(h, a).catch((ke) => {
          throw d.addIssue(r(h, ke)), d;
        }), T = await Reflect.apply(i, this, v);
        return await o._def.returns._def.type.parseAsync(T, a).catch((ke) => {
          throw d.addIssue(s(T, ke)), d;
        });
      });
    } else {
      const o = this;
      return w(function(...h) {
        const d = o._def.args.safeParse(h, a);
        if (!d.success)
          throw new E([r(h, d.error)]);
        const v = Reflect.apply(i, this, d.data), T = o._def.returns.safeParse(v, a);
        if (!T.success)
          throw new E([s(v, T.error)]);
        return T.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...e) {
    return new W({
      ...this._def,
      args: N.create(e).rest(V.create())
    });
  }
  returns(e) {
    return new W({
      ...this._def,
      returns: e
    });
  }
  implement(e) {
    return this.parse(e);
  }
  strictImplement(e) {
    return this.parse(e);
  }
  static create(e, t, r) {
    return new W({
      args: e || N.create([]).rest(V.create()),
      returns: t || V.create(),
      typeName: m.ZodFunction,
      ..._(r)
    });
  }
}
class re extends g {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    return this._def.getter()._parse({ data: t.data, path: t.path, parent: t });
  }
}
re.create = (n, e) => new re({
  getter: n,
  typeName: m.ZodLazy,
  ..._(e)
});
class se extends g {
  _parse(e) {
    if (e.data !== this._def.value) {
      const t = this._getOrReturnCtx(e);
      return l(t, {
        received: t.data,
        code: c.invalid_literal,
        expected: this._def.value
      }), y;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
}
se.create = (n, e) => new se({
  value: n,
  typeName: m.ZodLiteral,
  ..._(e)
});
function ze(n, e) {
  return new M({
    values: n,
    typeName: m.ZodEnum,
    ..._(e)
  });
}
class M extends g {
  _parse(e) {
    if (typeof e.data != "string") {
      const t = this._getOrReturnCtx(e), r = this._def.values;
      return l(t, {
        expected: b.joinValues(r),
        received: t.parsedType,
        code: c.invalid_type
      }), y;
    }
    if (this._def.values.indexOf(e.data) === -1) {
      const t = this._getOrReturnCtx(e), r = this._def.values;
      return l(t, {
        received: t.data,
        code: c.invalid_enum_value,
        options: r
      }), y;
    }
    return w(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const t of this._def.values)
      e[t] = t;
    return e;
  }
  get Values() {
    const e = {};
    for (const t of this._def.values)
      e[t] = t;
    return e;
  }
  get Enum() {
    const e = {};
    for (const t of this._def.values)
      e[t] = t;
    return e;
  }
  extract(e) {
    return M.create(e);
  }
  exclude(e) {
    return M.create(this.options.filter((t) => !e.includes(t)));
  }
}
M.create = ze;
class ae extends g {
  _parse(e) {
    const t = b.getValidEnumValues(this._def.values), r = this._getOrReturnCtx(e);
    if (r.parsedType !== u.string && r.parsedType !== u.number) {
      const s = b.objectValues(t);
      return l(r, {
        expected: b.joinValues(s),
        received: r.parsedType,
        code: c.invalid_type
      }), y;
    }
    if (t.indexOf(e.data) === -1) {
      const s = b.objectValues(t);
      return l(r, {
        received: r.data,
        code: c.invalid_enum_value,
        options: s
      }), y;
    }
    return w(e.data);
  }
  get enum() {
    return this._def.values;
  }
}
ae.create = (n, e) => new ae({
  values: n,
  typeName: m.ZodNativeEnum,
  ..._(e)
});
class q extends g {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    if (t.parsedType !== u.promise && t.common.async === !1)
      return l(t, {
        code: c.invalid_type,
        expected: u.promise,
        received: t.parsedType
      }), y;
    const r = t.parsedType === u.promise ? t.data : Promise.resolve(t.data);
    return w(r.then((s) => this._def.type.parseAsync(s, {
      path: t.path,
      errorMap: t.common.contextualErrorMap
    })));
  }
}
q.create = (n, e) => new q({
  type: n,
  typeName: m.ZodPromise,
  ..._(e)
});
class O extends g {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === m.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: t, ctx: r } = this._processInputParams(e), s = this._def.effect || null, a = {
      addIssue: (i) => {
        l(r, i), i.fatal ? t.abort() : t.dirty();
      },
      get path() {
        return r.path;
      }
    };
    if (a.addIssue = a.addIssue.bind(a), s.type === "preprocess") {
      const i = s.transform(r.data, a);
      return r.common.issues.length ? {
        status: "dirty",
        value: r.data
      } : r.common.async ? Promise.resolve(i).then((o) => this._def.schema._parseAsync({
        data: o,
        path: r.path,
        parent: r
      })) : this._def.schema._parseSync({
        data: i,
        path: r.path,
        parent: r
      });
    }
    if (s.type === "refinement") {
      const i = (o) => {
        const h = s.refinement(o, a);
        if (r.common.async)
          return Promise.resolve(h);
        if (h instanceof Promise)
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return o;
      };
      if (r.common.async === !1) {
        const o = this._def.schema._parseSync({
          data: r.data,
          path: r.path,
          parent: r
        });
        return o.status === "aborted" ? y : (o.status === "dirty" && t.dirty(), i(o.value), { status: t.value, value: o.value });
      } else
        return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((o) => o.status === "aborted" ? y : (o.status === "dirty" && t.dirty(), i(o.value).then(() => ({ status: t.value, value: o.value }))));
    }
    if (s.type === "transform")
      if (r.common.async === !1) {
        const i = this._def.schema._parseSync({
          data: r.data,
          path: r.path,
          parent: r
        });
        if (!X(i))
          return i;
        const o = s.transform(i.value, a);
        if (o instanceof Promise)
          throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: t.value, value: o };
      } else
        return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((i) => X(i) ? Promise.resolve(s.transform(i.value, a)).then((o) => ({ status: t.value, value: o })) : i);
    b.assertNever(s);
  }
}
O.create = (n, e, t) => new O({
  schema: n,
  typeName: m.ZodEffects,
  effect: e,
  ..._(t)
});
O.createWithPreprocess = (n, e, t) => new O({
  schema: e,
  effect: { type: "preprocess", transform: n },
  typeName: m.ZodEffects,
  ..._(t)
});
class A extends g {
  _parse(e) {
    return this._getType(e) === u.undefined ? w(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
A.create = (n, e) => new A({
  innerType: n,
  typeName: m.ZodOptional,
  ..._(e)
});
class z extends g {
  _parse(e) {
    return this._getType(e) === u.null ? w(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
z.create = (n, e) => new z({
  innerType: n,
  typeName: m.ZodNullable,
  ..._(e)
});
class ie extends g {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e);
    let r = t.data;
    return t.parsedType === u.undefined && (r = this._def.defaultValue()), this._def.innerType._parse({
      data: r,
      path: t.path,
      parent: t
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
ie.create = (n, e) => new ie({
  innerType: n,
  typeName: m.ZodDefault,
  defaultValue: typeof e.default == "function" ? e.default : () => e.default,
  ..._(e)
});
class me extends g {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e), r = {
      ...t,
      common: {
        ...t.common,
        issues: []
      }
    }, s = this._def.innerType._parse({
      data: r.data,
      path: r.path,
      parent: {
        ...r
      }
    });
    return le(s) ? s.then((a) => ({
      status: "valid",
      value: a.status === "valid" ? a.value : this._def.catchValue({
        get error() {
          return new E(r.common.issues);
        },
        input: r.data
      })
    })) : {
      status: "valid",
      value: s.status === "valid" ? s.value : this._def.catchValue({
        get error() {
          return new E(r.common.issues);
        },
        input: r.data
      })
    };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
me.create = (n, e) => new me({
  innerType: n,
  typeName: m.ZodCatch,
  catchValue: typeof e.catch == "function" ? e.catch : () => e.catch,
  ..._(e)
});
class ye extends g {
  _parse(e) {
    if (this._getType(e) !== u.nan) {
      const r = this._getOrReturnCtx(e);
      return l(r, {
        code: c.invalid_type,
        expected: u.nan,
        received: r.parsedType
      }), y;
    }
    return { status: "valid", value: e.data };
  }
}
ye.create = (n) => new ye({
  typeName: m.ZodNaN,
  ..._(n)
});
const Tt = Symbol("zod_brand");
class Be extends g {
  _parse(e) {
    const { ctx: t } = this._processInputParams(e), r = t.data;
    return this._def.type._parse({
      data: r,
      path: t.path,
      parent: t
    });
  }
  unwrap() {
    return this._def.type;
  }
}
class oe extends g {
  _parse(e) {
    const { status: t, ctx: r } = this._processInputParams(e);
    if (r.common.async)
      return (async () => {
        const a = await this._def.in._parseAsync({
          data: r.data,
          path: r.path,
          parent: r
        });
        return a.status === "aborted" ? y : a.status === "dirty" ? (t.dirty(), $e(a.value)) : this._def.out._parseAsync({
          data: a.value,
          path: r.path,
          parent: r
        });
      })();
    {
      const s = this._def.in._parseSync({
        data: r.data,
        path: r.path,
        parent: r
      });
      return s.status === "aborted" ? y : s.status === "dirty" ? (t.dirty(), {
        status: "dirty",
        value: s.value
      }) : this._def.out._parseSync({
        data: s.value,
        path: r.path,
        parent: r
      });
    }
  }
  static create(e, t) {
    return new oe({
      in: e,
      out: t,
      typeName: m.ZodPipeline
    });
  }
}
class _e extends g {
  _parse(e) {
    const t = this._def.innerType._parse(e);
    return X(t) && (t.value = Object.freeze(t.value)), t;
  }
}
_e.create = (n, e) => new _e({
  innerType: n,
  typeName: m.ZodReadonly,
  ..._(e)
});
const Ue = (n, e = {}, t) => n ? F.create().superRefine((r, s) => {
  var a, i;
  if (!n(r)) {
    const o = typeof e == "function" ? e(r) : typeof e == "string" ? { message: e } : e, h = (i = (a = o.fatal) !== null && a !== void 0 ? a : t) !== null && i !== void 0 ? i : !0, d = typeof o == "string" ? { message: o } : o;
    s.addIssue({ code: "custom", ...d, fatal: h });
  }
}) : F.create(), St = {
  object: x.lazycreate
};
var m;
(function(n) {
  n.ZodString = "ZodString", n.ZodNumber = "ZodNumber", n.ZodNaN = "ZodNaN", n.ZodBigInt = "ZodBigInt", n.ZodBoolean = "ZodBoolean", n.ZodDate = "ZodDate", n.ZodSymbol = "ZodSymbol", n.ZodUndefined = "ZodUndefined", n.ZodNull = "ZodNull", n.ZodAny = "ZodAny", n.ZodUnknown = "ZodUnknown", n.ZodNever = "ZodNever", n.ZodVoid = "ZodVoid", n.ZodArray = "ZodArray", n.ZodObject = "ZodObject", n.ZodUnion = "ZodUnion", n.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", n.ZodIntersection = "ZodIntersection", n.ZodTuple = "ZodTuple", n.ZodRecord = "ZodRecord", n.ZodMap = "ZodMap", n.ZodSet = "ZodSet", n.ZodFunction = "ZodFunction", n.ZodLazy = "ZodLazy", n.ZodLiteral = "ZodLiteral", n.ZodEnum = "ZodEnum", n.ZodEffects = "ZodEffects", n.ZodNativeEnum = "ZodNativeEnum", n.ZodOptional = "ZodOptional", n.ZodNullable = "ZodNullable", n.ZodDefault = "ZodDefault", n.ZodCatch = "ZodCatch", n.ZodPromise = "ZodPromise", n.ZodBranded = "ZodBranded", n.ZodPipeline = "ZodPipeline", n.ZodReadonly = "ZodReadonly";
})(m || (m = {}));
const Et = (n, e = {
  message: `Input not instance of ${n.name}`
}) => Ue((t) => t instanceof n, e), We = S.create, Fe = P.create, It = ye.create, Ot = D.create, qe = G.create, Zt = L.create, Nt = pe.create, Ct = Q.create, At = K.create, Rt = F.create, jt = V.create, Pt = R.create, Dt = he.create, Mt = I.create, Vt = x.create, Lt = x.strictCreate, $t = ee.create, zt = xe.create, Bt = te.create, Ut = N.create, Wt = ne.create, Ft = fe.create, qt = $.create, Yt = W.create, Ht = re.create, Jt = se.create, Xt = M.create, Gt = ae.create, Qt = q.create, Me = O.create, Kt = A.create, en = z.create, tn = O.createWithPreprocess, nn = oe.create, rn = () => We().optional(), sn = () => Fe().optional(), an = () => qe().optional(), on = {
  string: (n) => S.create({ ...n, coerce: !0 }),
  number: (n) => P.create({ ...n, coerce: !0 }),
  boolean: (n) => G.create({
    ...n,
    coerce: !0
  }),
  bigint: (n) => D.create({ ...n, coerce: !0 }),
  date: (n) => L.create({ ...n, coerce: !0 })
}, cn = y;
var p = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: J,
  setErrorMap: lt,
  getErrorMap: de,
  makeIssue: ue,
  EMPTY_PATH: pt,
  addIssueToContext: l,
  ParseStatus: k,
  INVALID: y,
  DIRTY: $e,
  OK: w,
  isAborted: Se,
  isDirty: Ee,
  isValid: X,
  isAsync: le,
  get util() {
    return b;
  },
  get objectUtil() {
    return Te;
  },
  ZodParsedType: u,
  getParsedType: j,
  ZodType: g,
  ZodString: S,
  ZodNumber: P,
  ZodBigInt: D,
  ZodBoolean: G,
  ZodDate: L,
  ZodSymbol: pe,
  ZodUndefined: Q,
  ZodNull: K,
  ZodAny: F,
  ZodUnknown: V,
  ZodNever: R,
  ZodVoid: he,
  ZodArray: I,
  ZodObject: x,
  ZodUnion: ee,
  ZodDiscriminatedUnion: xe,
  ZodIntersection: te,
  ZodTuple: N,
  ZodRecord: ne,
  ZodMap: fe,
  ZodSet: $,
  ZodFunction: W,
  ZodLazy: re,
  ZodLiteral: se,
  ZodEnum: M,
  ZodNativeEnum: ae,
  ZodPromise: q,
  ZodEffects: O,
  ZodTransformer: O,
  ZodOptional: A,
  ZodNullable: z,
  ZodDefault: ie,
  ZodCatch: me,
  ZodNaN: ye,
  BRAND: Tt,
  ZodBranded: Be,
  ZodPipeline: oe,
  ZodReadonly: _e,
  custom: Ue,
  Schema: g,
  ZodSchema: g,
  late: St,
  get ZodFirstPartyTypeKind() {
    return m;
  },
  coerce: on,
  any: Rt,
  array: Mt,
  bigint: Ot,
  boolean: qe,
  date: Zt,
  discriminatedUnion: zt,
  effect: Me,
  enum: Xt,
  function: Yt,
  instanceof: Et,
  intersection: Bt,
  lazy: Ht,
  literal: Jt,
  map: Ft,
  nan: It,
  nativeEnum: Gt,
  never: Pt,
  null: At,
  nullable: en,
  number: Fe,
  object: Vt,
  oboolean: an,
  onumber: sn,
  optional: Kt,
  ostring: rn,
  pipeline: nn,
  preprocess: tn,
  promise: Qt,
  record: Wt,
  set: qt,
  strictObject: Lt,
  string: We,
  symbol: Nt,
  transformer: Me,
  tuple: Ut,
  undefined: Ct,
  union: $t,
  unknown: jt,
  void: Dt,
  NEVER: cn,
  ZodIssueCode: c,
  quotelessJson: ut,
  ZodError: E
});
const Ye = (n) => n != null, dn = p.any().refine((n) => Ye(n));
function un() {
  return p.object({
    __typename: p.literal("AccountSnapshotLocalState").optional()
  });
}
function ln() {
  return p.object({
    __typename: p.literal("AccountSnapshotState").optional(),
    actualsComparison: p.array(He().nullable()).nullable(),
    end: p.string().nullable(),
    id: p.string(),
    ownerId: p.string().nullable(),
    ownerType: p.string().nullable(),
    period: p.string().nullable(),
    snapshotAccount: p.array(Xe().nullable()).nullable(),
    start: p.string().nullable()
  });
}
function He() {
  return p.object({
    __typename: p.literal("ActualsComparison").optional(),
    currency: p.string().nullable(),
    month: p.string().nullable(),
    netExpenses: Je().nullable(),
    reportedActuals: p.number().nullable()
  });
}
function Je() {
  return p.object({
    __typename: p.literal("ActualsComparisonNetExpenses").optional(),
    offChainIncluded: Oe().nullable(),
    onChainOnly: Oe()
  });
}
function Oe() {
  return p.object({
    __typename: p.literal("ActualsComparisonNetExpensesItem").optional(),
    amount: p.number().nullable(),
    difference: p.number().nullable()
  });
}
function Ze() {
  return p.object({
    end: p.string()
  });
}
function Ne() {
  return p.object({
    id: p.string()
  });
}
function Ce() {
  return p.object({
    ownerId: p.string()
  });
}
function Ae() {
  return p.object({
    ownerType: p.string()
  });
}
function Re() {
  return p.object({
    period: p.string()
  });
}
function je() {
  return p.object({
    start: p.string()
  });
}
function Xe() {
  return p.object({
    __typename: p.literal("SnapshotAccount").optional(),
    accountAddress: p.string().nullable(),
    accountLabel: p.string().nullable(),
    accountType: p.string().nullable(),
    groupAccountId: p.string().nullable(),
    id: p.string(),
    offChain: p.boolean().nullable(),
    snapshotAccountBalance: p.array(Ge().nullable()).nullable(),
    snapshotAccountTransaction: p.array(Qe().nullable()).nullable(),
    upstreamAccountId: p.string().nullable()
  });
}
function Ge() {
  return p.object({
    __typename: p.literal("SnapshotAccountBalance").optional(),
    id: p.string().nullable(),
    includesOffChain: p.boolean().nullable(),
    inflow: p.number().nullable(),
    initialBalance: p.number().nullable(),
    newBalance: p.number().nullable(),
    outflow: p.number().nullable(),
    token: p.string().nullable()
  });
}
function Qe() {
  return p.object({
    __typename: p.literal("SnapshotAccountTransaction").optional(),
    amount: p.number().nullable(),
    block: p.number().nullable(),
    counterParty: p.string().nullable(),
    counterPartyName: p.string().nullable(),
    id: p.string(),
    timestamp: p.string().nullable(),
    token: p.string().nullable(),
    txHash: p.string().nullable(),
    txLabel: p.string().nullable()
  });
}
const Tn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AccountSnapshotLocalStateSchema: un,
  AccountSnapshotStateSchema: ln,
  ActualsComparisonNetExpensesItemSchema: Oe,
  ActualsComparisonNetExpensesSchema: Je,
  ActualsComparisonSchema: He,
  SetEndInputSchema: Ze,
  SetIdInputSchema: Ne,
  SetOwnerIdInputSchema: Ce,
  SetOwnerTypeInputSchema: Ae,
  SetPeriodInputSchema: Re,
  SetStartInputSchema: je,
  SnapshotAccountBalanceSchema: Ge,
  SnapshotAccountSchema: Xe,
  SnapshotAccountTransactionSchema: Qe,
  definedNonNullAnySchema: dn,
  isDefinedNonNullAny: Ye
}, Symbol.toStringTag, { value: "Module" })), B = {
  setIdOperation(n, e) {
    n.id = e.input.id;
  },
  setOwnerIdOperation(n, e) {
    n.ownerId = e.input.ownerId;
  },
  setOwnerTypeOperation(n, e) {
    n.ownerType = e.input.ownerType;
  },
  setPeriodOperation(n, e) {
    n.period = e.input.period;
  },
  setStartOperation(n, e) {
    n.start = e.input.start;
  },
  setEndOperation(n, e) {
    n.end = e.input.end;
  }
}, pn = (n, e, t) => {
  if (C.isBaseAction(e))
    return n;
  switch (e.type) {
    case "SET_ID":
      Ne().parse(e.input), B.setIdOperation(n[e.scope], e, t);
      break;
    case "SET_OWNER_ID":
      Ce().parse(e.input), B.setOwnerIdOperation(n[e.scope], e, t);
      break;
    case "SET_OWNER_TYPE":
      Ae().parse(e.input), B.setOwnerTypeOperation(n[e.scope], e, t);
      break;
    case "SET_PERIOD":
      Re().parse(e.input), B.setPeriodOperation(n[e.scope], e, t);
      break;
    case "SET_START":
      je().parse(e.input), B.setStartOperation(n[e.scope], e, t);
      break;
    case "SET_END":
      Ze().parse(e.input), B.setEndOperation(n[e.scope], e, t);
      break;
    default:
      return n;
  }
}, ge = C.createReducer(pn), hn = { id: "", ownerId: "", ownerType: "", period: "", start: "", end: "", actualsComparison: [], snapshotAccount: [] }, fn = {}, H = {
  fileExtension: "phas",
  createState(n) {
    return { global: { ...hn, ...n == null ? void 0 : n.global }, local: { ...fn, ...n == null ? void 0 : n.local } };
  },
  createExtendedState(n) {
    return C.createExtendedState(
      { ...n, documentType: "powerhouse/account-snapshot" },
      H.createState
    );
  },
  createDocument(n) {
    return C.createDocument(
      H.createExtendedState(n),
      H.createState
    );
  },
  saveToFile(n, e, t) {
    return C.saveToFile(n, e, "phas", t);
  },
  saveToFileHandle(n, e) {
    return C.saveToFileHandle(n, e);
  },
  loadFromFile(n) {
    return C.loadFromFile(n, ge);
  },
  loadFromInput(n) {
    return C.loadFromInput(n, ge);
  }
}, { createAction: Y } = C, Ke = (n) => Y(
  "SET_ID",
  { ...n },
  void 0,
  Ne,
  "global"
), et = (n) => Y(
  "SET_OWNER_ID",
  { ...n },
  void 0,
  Ce,
  "global"
), tt = (n) => Y(
  "SET_OWNER_TYPE",
  { ...n },
  void 0,
  Ae,
  "global"
), nt = (n) => Y(
  "SET_PERIOD",
  { ...n },
  void 0,
  Re,
  "global"
), rt = (n) => Y(
  "SET_START",
  { ...n },
  void 0,
  je,
  "global"
), st = (n) => Y(
  "SET_END",
  { ...n },
  void 0,
  Ze,
  "global"
);
class mn extends Ve {
  setId(e) {
    return this.dispatch(Ke(e));
  }
  setOwnerId(e) {
    return this.dispatch(et(e));
  }
  setOwnerType(e) {
    return this.dispatch(tt(e));
  }
  setPeriod(e) {
    return this.dispatch(nt(e));
  }
  setStart(e) {
    return this.dispatch(rt(e));
  }
  setEnd(e) {
    return this.dispatch(st(e));
  }
}
const be = class be extends Ve {
  constructor(e, t) {
    super(ge, H.createDocument(e), t);
  }
  saveToFile(e, t) {
    return super.saveToFile(e, be.fileExtension, t);
  }
  loadFromFile(e) {
    return super.loadFromFile(e);
  }
  static async fromFile(e) {
    const t = new this();
    return await t.loadFromFile(e), t;
  }
};
Pe(be, "fileExtension", "phas");
let ve = be;
ot(ve, [
  mn
]);
const yn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  setEnd: st,
  setId: Ke,
  setOwnerId: et,
  setOwnerType: tt,
  setPeriod: nt,
  setStart: rt
}, Symbol.toStringTag, { value: "Module" })), _n = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" })), gn = ve, vn = { ...H, ..._n }, bn = { ...ct, ...yn }, Sn = {
  Document: gn,
  reducer: ge,
  actions: bn,
  utils: vn,
  documentModel: dt
};
export {
  ve as A,
  gn as D,
  bn as a,
  Tn as b,
  dt as d,
  Sn as m,
  ge as r,
  vn as u,
  p as z
};
